import Operation from "antd/lib/transfer/operation";

export const Admin = ['Super Alumni Administrator', 'Alumni Council Committee', 'Alumni CST Support', 'Alumni Admin', 'National Alumni Administration Professional', 'National Professional Alumni Administrator', 'National Volunteer Alumni Administrator', 'National Volunteer Affinity Group Administrator', 'Scout Executive', 'Registration Support', 'Council Professional Alumni Administrator']
export const AlumniSpecialist = ['Alumni Specialist']
export const MaintainAlumni = []
export const ReportDownload = []

export const DB_to_UI = {
  nesa_state: 'nesastate'
}

const toLowerCaseObj = (obj) =>
  Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [
      k.toLowerCase(),
      typeof v === "string" ? v.toLowerCase() : v
    ])
  );

export const OPERATOR_MAP = {
  inlist: "InList",
  equals: "Equals",

  range: "Range",
  LTE: "LTE",
  GTE: "GTE",
  GT: "GT",

  NBV: "NBV",
  BV: "BV",
  
  doesnotmatch: "Does Not Match",
  contains: "Contains",
  doesnotcontain: "Does Not Contain",
  startswith: "Starts With",

  doesnotstartswith: "Does Not Start With",
  doesnotstartwith: "Does Not Start With",

  endswith: "Ends With",
  doesnotendswith: "Does Not End With",
  doesnotendwith: "Does Not End With",
  endswithdoesnotmatch: "Does Not End With"
}


export const OPERATOR_NORMALIZER = {
  equals: "Equals",
  doesnotmatch: "Does Not Match",

  inlist: "InList",
  range: "Range",

  lte: "Less Than Equals",
  gte: "Greater Than Equals",
  gt: "Greater Than",

  nbv: "Is Not Blank",
  bv: "Is Blank",
  
  contains: "Contains",

  notcontains: "Not Contains",
  doesnotcontain: "Does Not Contain",

  startswith: "Starts With",
  notstartswith: "Not Starts With",

  doesnotstartswith: "Does Not Start With",
  doesnotstartwith: "Does Not Start With",

  endswith: "Ends With",
  doesnotendswith: "Does Not End With",
  doesnotendwith: "Does Not End With",
  endswithdoesnotmatch: "Does Not End With",


};

export const filters = [
  'ProgramIDInList', "ProgramIDBV", "ProgramIDNBV",
  'SKPersonID', 'SKPersonIDDoesNotMatch',
  'PersonGUID', 'PersonGUIDDoesNotMatch',
  'PersonID', 'PersonIDDoesNotMatch',

  "PrefixBV", "PrefixNBV", 'PrefixContains', 'PrefixDoesNotMatch', 'PrefixEndsWith', 'PrefixInlist', 'PrefixStartsWith',
  "SuffixBV", "SuffixNBV", 'SuffixContains', 'SuffixDoesNotMatch', 'SuffixEndsWith', 'SuffixInlist', 'SuffixStartsWith',

  'FirstName', 'FirstNameInlist', 'FirstNameDoesNotMatch', 'FirstNameContains', 'FirstNameDoesNotContain', 'FirstNameStartsWith', 'FirstNameDoesNotStartWith', 'FirstNameEndsWith', 'FirstNameBV', 'FirstNameNBV',

  'LastName', 'LastNameInlist', 'LastNameDoesNotMatch', 'LastNameContains', 'LastNameDoesNotContain', 'LastNameStartsWith', 'LastNameDoesNotStartWith', 'LastNameEndsWith', 'LastNameBV', 'LastNameNBV',

  'MiddleName', 'MiddleNameInlist', 'MiddleNameDoesNotMatch', 'MiddleNameContains', 'MiddleNameDoesNotContain', 'MiddleNameStartsWith', 'MiddleNameDoesNotStartWith', 'MiddleNameEndsWith', 'MiddleNameBV', 'MiddleNameNBV',

  'MaidenName', 'MaidenNameInlist', 'MaidenNameDoesNotMatch', 'MaidenNameContains', 'MaidenNameDoesNotContain', 'MaidenNameStartsWith', 'MaidenNameDoesNotStartWith', 'MaidenNameEndsWith', 'MaidenNameBV', 'MaidenNameNBV',

  'CommonName', 'CommonNameInlist', 'CommonNameDoesNotMatch', 'CommonNameContains', 'CommonNameDoesNotContain', 'CommonNameStartsWith', 'CommonNameDoesNotStartWith', 'CommonNameEndsWith', 'CommonNameBV', 'CommonNameNBV',

  'Prefix',
  'Suffix',

  'Home_AddressLine1', 'Home_AddressLine1Contains', 'Home_AddressLine1DoesNotMatch', 'Home_AddressLine1Inlist', 'Home_AddressLine1StartsWith', 'Home_AddressLine1EndsWith', 'Home_AddressLine1BV', 'Home_AddressLine1NBV',
  'Home_AddressLine2', 'Home_AddressLine2Contains', 'Home_AddressLine2DoesNotMatch', 'Home_AddressLine2Inlist', 'Home_AddressLine2StartsWith', 'Home_AddressLine2EndsWith', 'Home_AddressLine2BV', 'Home_AddressLine2NBV',
  'Home_AddressLine3', 'Home_AddressLine3Contains', 'Home_AddressLine3DoesNotMatch', 'Home_AddressLine3Inlist', 'Home_AddressLine3StartsWith', 'Home_AddressLine3EndsWith', 'Home_AddressLine3NBV', 'Home_AddressLine3BV', 'Home_AddressLine3NBV',

  'HomeCity', 'HomeCityDoesNotMatch', 'HomeCityContains', 'HomeCityDoesNotContain', 'HomeCityInlist', 'HomeCityStartsWith', 'HomeCityDoesNotStartWith', 'HomeCityEndsWith', 'HomeCityBV', 'HomeCityNBV',

  //AAG-1402 #41 - as per Oleg, home_zip parameters sets filter for home_zip5. Need to update doc to remove home_zip and use only home_zip5 - 09/30/26
  // 'Home_Zip', 'Home_ZipContains', 'Home_ZipDoesNotMatch', 'Home_ZipInlist', 'Home_ZipStartsWith', 'Home_ZipEndsWith', 'Home_ZipBV', 'Home_ZipNBV', 
  'Home_Zip4',  'Home_Zip4DoesNotMatch', 'Home_Zip4Inlist', 'Home_Zip4Contains', 'Home_Zip4StartsWith', 'Home_Zip4EndsWith', 'Home_Zip4BV', 'Home_Zip4NBV',
  'Home_Zip5', 'Home_Zip5_range', 'Home_Zip5Inlist', 'Home_Zip5DoesNotMatch', 'Home_Zip5Contains', 'Home_Zip5StartsWith',  'Home_Zip5EndsWith', 'Home_Zip5BV', 'Home_Zip5NBV',

  'Business_AddressLine1', 'Business_AddressLine1Contains', 
  'Business_AddressLine2', 'Business_AddressLine2Contains', 
  'Business_AddressLine3', 'Business_AddressLine3Contains',

  "BusinessCity", 'BusinessCityInlist', "BusinessCityDoesNotMatch", "BusinessCityContains", "BusinessCityDoesNotContain", "BusinessCityStartsWith", "BusinessCityDoesNotStartWith", "BusinessCityEndsWith", "BusinessCityBV", "BusinessCityNBV",

  "BusinessState", 'BusinessStateInlist', 'BusinessStateDoesNotMatch', "BusinessStateContains", "BusinessStateStartsWith", "BusinessStateDoesNotContain", 'BusinessStateEndsWith', "BusinessStateBV", "BusinessStateNBV",

  'Business_Zip4', 'Business_Zip4Inlist', 'Business_Zip4DoesNotMatch','Business_Zip4Contains', 'Business_Zip4StartsWith', 'Business_Zip4EndsWith', "Business_Zip4BV", "Business_Zip4NBV",
  'Business_Zip5', 'Business_Zip5_range', 'Business_Zip5Inlist', 'Business_Zip5DoesNotMatch','Business_Zip5Contains', 'Business_Zip5StartsWith', 'Business_Zip5EndsWith', "Business_Zip5BV", "Business_Zip5NBV",

  'BusinessCountry', "BusinessCountryContains", 'BusinessCountryInlist', 'BusinessCountryDoesNotMatch', 'BusinessCountryStartsWith','BusinessCountryDoesNotStartWith','BusinessCountryEndsWith', 'BusinessCountryDoesNotEndWith', "BusinessCountryBV", "BusinessCountryNBV",

  'HomeState', 'HomeStateInlist', 'HomeStateDoesNotMatch', 'HomeStateContains', 'HomeStateDoesNotContain',  'HomeStateStartsWith', 
  'HomeStateDoesNotStartWith', 'HomeStateEndsWith', 'HomeStateBV', 'HomeStateNBV',

  'HomeCountry', 'HomeCountryContains', 'HomeCountryInlist', 'HomeCountryDoesNotMatch', 'HomeCountryStartsWith', 'HomeCountryDoesNotStartWith', 'HomeCountryEndsWith', 'HomeCountryBV', 'HomeCountryNBV', 

  "ShippingCity", "ShippingCityDoesNotMatch", 'ShippingCityInlist', "ShippingCityContains", "ShippingCityDoesNotContain", "ShippingCityStartsWith", "ShippingCityDoesNotStartWith", 'ShippingCityEndsWith', "ShippingCityBV", "ShippingCityNBV",

  "Shipping_Zip4", "Shipping_Zip4Inlist", 'Shipping_Zip4DoesNotMatch', 'Shipping_Zip4Contains', 'Shipping_Zip4StartsWith', 'Shipping_Zip4EndsWith', "Shipping_Zip4BV", "Shipping_Zip4NBV",

  'ShippingCountry', 'ShippingCountryInlist', 'ShippingCountryStartsWith', 'ShippingCountryContains', 'ShippingCountryDoesNotMatch', 'ShippingCountryEndsWith', "ShippingCountryBV", "ShippingCountryNBV",
  'Shipping_State', 'Shipping_StateDoesNotMatch', 'Shipping_StateContains', 'Shipping_StateInlist', 'Shipping_StateStartsWith','Shipping_StateEndsWith', "Shipping_StateBV", "Shipping_StateNBV",

  'Shipping_Zip5', 'Shipping_Zip5Inlist', 'Shipping_Zip5_range', 'Shipping_Zip5DoesNotMatch', 'Shipping_Zip5Contains', 'Shipping_Zip5StartsWith', 'Shipping_Zip5EndsWith', "Shipping_Zip5BV", "Shipping_Zip5NBV",

  'NESA_AddressLine1','NESA_AddressLine1Contains',
  'NESA_AddressLine2','NESA_AddressLine2Contains',
  'NESA_AddressLine3','NESA_AddressLine3Contains',

  'NESACity', 'NESACityInlist', 'NESACityDoesNotMatch', 'NESACityContains', 'NESACityDoesNotContain', 'NESACityStartsWith', 'NESACityDoesNotStartWith', 'NESACityEndsWith', 'NESACityBV', 'NESACityNBV',

  'NESAState','NESAStateInlist', 'NESAStateDoesNotMatch', 'NESAStateContains', 'NESAStateDoesNotContain', 'NESAStateStartsWith', 'NESAStateDoesNotStartWith', 'NESAStateEndsWith', "NESA_StateBV", "NESA_StateNBV",

  'NESACountry', 'NESACountryContains', 'NESACountryInlist', 'NESACountryDoesNotMatch', 'NESACountryStartsWith', 'NESACountryDoesNotStartWith', 'NESACountryEndsWith', 'NESACountryEndsWithDoesNotMatch', 'NESACountryBV', 'NESACountryNBV',

  "NESA_Zip4", "NESA_Zip4Inlist", 'NESA_Zip4_range', 'NESA_Zip4DoesNotMatch', 'NESA_Zip4Contains', 'NESA_Zip4StartsWith', 'NESA_Zip4EndsWith', 'NESA_Zip4BV', 'NESA_Zip4NBV',

  "NESA_Zip5", "NESA_Zip5Inlist", 'NESA_Zip5_range', 'NESA_Zip5DoesNotMatch', 'NESA_Zip5Contains', 'NESA_Zip5StartsWith', 'NESA_Zip5EndsWith', "NESA_Zip5BV", "NESA_Zip5NBV",

  'CouncilNumber', 'CouncilNumberDoesNotMatch', 'CouncilNumberInlist', 'CouncilNumberGT', 'CouncilNumberLTE', 'CouncilNumberBV', 'CouncilNumberNBV', //AAG-1264 need to implement isEagleOnly flag in API

       
  'OwnerCouncilName', 'OwnerCouncilNameDoesNotMatch', 'OwnerCouncilNameInlist', 'OwnerCouncilNameContains', 'OwnerCouncilNameDoesNotContain', 'OwnerCouncilNameStartsWith', 'OwnerCouncilNameDoesNotStartWith', 'OwnerCouncilNameEndsWith', 'OwnerCouncilNameBV', 'OwnerCouncilNameNBV',

  'OwnerCouncilNumber', 'OwnerCouncilNumberDoesNotMatch', 'OwnerCouncilNumberInlist', 'OwnerCouncilNumberEndsWith',
  'OwnerCouncilNumberContains', 'OwnerCouncilNumberBV', 'OwnerCouncilNumberNBV',
  // 'OwnerCouncilNumberDoesNotContain', 'OwnerCouncilNumberStartsWith', 'OwnerCouncilNumberDoesNotStartWith', 

  //Dropped this column since the ESB lookup API, while Igor’s report uses a different database. Because the values stored in the two systems are formatted differently, --AAG-1357
  
  //  'OwnerCouncilNameAndNumberInlist',  'OwnerCouncilNameAndNumberContains',  'OwnerCouncilNameAndNumberStartsWith', 'OwnerCouncilNameAndNumberDoesNotStartWith', 'OwnerCouncilNameAndNumberDoesNotMatch', "OwnerCouncilNameAndNumberBV", "OwnerCouncilNameAndNumberNBV",
  
  'EagleCouncilName', 'EagleCouncilNameDoesNotContain', 'EagleCouncilNameInlist', 'EagleCouncilNameContains', 'EagleCouncilNameDoesNotMatch', 'EagleCouncilNameStartsWith', 'EagleCouncilNameDoesNotStartWith', 'EagleCouncilNameEndsWith', 'EagleCouncilNameBV', 'EagleCouncilNameNBV',

  'EagleCouncilNumber', 'EagleCouncilNumberDoesNotMatch', 'EagleCouncilNumberInlist', 'EagleCouncilNumberEndsWith',
  'EagleCouncilNumberContains', 'EagleCouncilNumberBV', 'EagleCouncilNumberNBV',
  // 'EagleCouncilNumberDoesNotContain', 'EagleCouncilNumberStartsWith', 'EagleCouncilNumberDoesNotStartWith', 

  //Dropped this column since the ESB lookup API, while Igor’s report uses a different database. Because the values stored in the two systems are formatted differently, --AAG-1357

//  'EagleCouncilNameAndNumberInlist', 'EagleCouncilNameAndNumberContains', 'EagleCouncilNameAndNumberDoesNotContain', 'EagleCouncilNameAndNumberDoesNotMatch', 'EagleCouncilNameAndNumberStartsWith', 'EagleCouncilNameAndNumberDoesNotStartWith', "EagleCouncilNameAndNumberBV", "EagleCouncilNameAndNumberNBV",

  'EagleScoutUnitCity', 'EagleScoutUnitCityInlist', 'EagleScoutUnitCityContains', 'EagleScoutUnitCityDoesNotContain', 'EagleScoutUnitCityDoesNotMatch', 'EagleScoutUnitCityStartsWith', 'EagleScoutUnitCityDoesNotStartWith', 'EagleScoutUnitCityEndsWith', "EagleScoutUnitCityBV", "EagleScoutUnitCityNBV",

  'EagleScoutUnitState', 'EagleScoutUnitState_range', 'EagleScoutUnitStateDoesNotMatch', 'EagleScoutUnitStateInlist', 'EagleScoutUnitStateContains', 'EagleScoutUnitStateStartsWith', 'EagleScoutUnitStateEndsWith', 'EagleScoutUnitStateBV', 'EagleScoutUnitStateNBV',

  'EagleScoutUnitNumber', 'EagleScoutUnitNumberInlist', 'EagleScoutUnitNumberDoesNotMatch', 'EagleScoutUnitNumberContains', 'EagleScoutUnitNumberDoesNotContain', 'EagleScoutUnitNumberStartsWith', 'EagleScoutUnitNumberDoesNotStartWith', 'EagleScoutUnitNumberEndsWith', "EagleScoutUnitNumberBV", "EagleScoutUnitNumberNBV",

  'EagleScoutCountry', 'EagleScoutCountryInlist', 'EagleScoutCountryDoesNotMatch', 'EagleScoutCountryContains','EagleScoutCountryDoesNotContain', 'EagleScoutCountryStartsWith', 'EagleScoutCountryDoesNotStartWith', 'EagleScoutCountryEndsWith', "EagleScoutCountryBV", "EagleScoutCountryNBV",

  'EagleScoutUnitType', 'EagleScoutUnitTypeInlist', 'EagleScoutUnitTypeDoesNotMatch', 'EagleScoutUnitTypeContains', 'EagleScoutUnitTypeDoesNotContain', 'EagleScoutUnitTypeStartsWith', 'EagleScoutUnitTypeDoesNotStartWith', 'EagleScoutUnitTypeEndsWith', "EagleScoutUnitTypeBV", "EagleScoutUnitTypeNBV",

  'FacebookNameStartsWith',
  'TwitterNameStartsWith',
  'LinkedinNameStartsWith',
  'InstagramNameStartsWith',

  'HobbiesAndInterests', 'HobbiesAndInterestsContains', 'HobbiesAndInterestsDoesNotContain', 'HobbiesAndInterestsDoesNotMatch', 'HobbiesAndInterestsDoesNotStartWith', 'HobbiesAndInterestsInlist', 'HobbiesAndInterestsStartsWith', 'HobbiesAndInterestsEndsWith', 'HobbiesAndInterestsBV', 'HobbiesAndInterestsNBV',

  // 'BusinessAndCareer', 'BusinessAndCareerDoesNotMatch', 'BusinessAndCareerInlist', 'BusinessAndCareerStartsWith', 'BusinessAndCareerEndsWith', 
  'BusinessAndCareerContains','BusinessAndCareerDoesNotContain', //confirmed with Mike (meeting) /and Paul - 10/06/20 on slack
  // "BusinessAndCareerBV", "BusinessAndCareerNBV",

  // 'NationalAward', 'NationalAwardInlist', 'NationalAwardDoesNotMatch', "NationalAwardBV", "NationalAwardNBV",
  'NationalAwardID', 'NationalAwardIDInlist', 'NationalAwardIDDoesNotMatch', 'NationalAwardIDBV', 'NationalAwardIDNBV', 

  // 'AffinityGroup', 'AffinityGroupDoesNotMatch', 'AffinityGroupInlist',
   'AffinityGroupContains', 'AffinityGroupStartsWith', 'AffinityGroupEndsWith', 
  //  'AffinityGroupBV', 'AffinityGroupNBV',

  'AffinityGroupID',  'AffinityGroupIDDoesNotMatch', 'AffinityGroupIDInlist', 'AffinityGroupIDBV', 'AffinityGroupIDNBV',

  'ScoutingAffiliation', 'ScoutingAffiliationDoesNotMatch', 'ScoutingAffiliationInlist', 'ScoutingAffiliationStartsWith', 'ScoutingAffiliationEndsWith', 'ScoutingAffiliationContains', "ScoutingAffiliation_BV", "ScoutingAffiliation_NBV",

  'ScoutingAffiliationID', 'ScoutingAffiliationIDBV', 'ScoutingAffiliationIDDoesNotMatch', 'ScoutingAffiliationIDInlist', 'ScoutingAffiliationIDNBV', 
  
  'CouncilAffiliation', 'CouncilAffiliationDoesNotMatch', 'CouncilAffiliationInlist', 'CouncilAffiliationGT', 'CouncilAffiliationLTE', 'CouncilAffiliationBV', 'CouncilAffiliationNBV',

  //Oleg mentioned that we stopped retrieving Positions related filters after 03/25/2024.
  // Paul also confirmed that he does not want to re-implement it on Teams on 08/10/2026.
  // 'PositionName', 'PositionNameInlist', 'PositionNameContains', 'PositionNameDoesNotContain', 'PositionNameDoesNotMatch',  "PositionNameBV", "PositionNameNBV",

  // 'PositionStartDate', 'PositionStartDate_range', 'PositionStartDateDoesNotMatch', 'PositionStartDateGTE', 'PositionStartDateLTE',
  // 'PositionEndDate', 'PositionEndDate_range', 'PositionEndDateDoesNotMatch', 'PositionEndDateGTE', 'PositionEndDateLTE',

  'MembershipType', 'MembershipTypeDoesNotMatch', //Since membershiptype has only two values, the following operators are unnecessary AAG-1407 - release 4 (Issue #24)
  // 'MembershipTypeInlist', 'MembershipTypeStartsWith', 'MembershipTypeEndsWith', 'MembershipTypeContains', 
  "MembershipTypeBV", "MembershipTypeNBV",

  'MembershipStatus', 'MembershipStatusDoesNotMatch', 'MembershipStatusInlist', 'MembershipStatusStartsWith', 'MembershipStatusEndsWith', 'MembershipStatusContains', "MembershipStatusBV", "MembershipStatusNBV",

  'DateOfBirth', 'DateOfBirth_range', 'DateOfBirthLTE', 'DateOfBirthGTE', 'DateOfBirthDoesNotMatch', 

  'DateOfDeath', 'DateOfDeath_range', 'DateOfDeathLTE', 'DateOfDeathGTE', 'DateOfDeathDoesNotMatch',
  'BoardOfReviewDT', 'BoardOfReviewDT_range', 'BoardOfReviewDTLTE', 'BoardOfReviewDTGTE', 'BoardOfReviewDTDoesNotMatch',
  
  'EthnicityID', 'EthnicityIDDoesNotMatch',
  'Ethnicity', 'EthnicityContains', 'EthnicityDoesNotMatch',  'EthnicityInlist', 'EthnicityStartsWith', 'EthnicityEndsWith', "EthnicityBV", "EthnicityNBV",

  'Email', 'EmailInlist', 'EmailDoesNotMatch', 'EmailContains', 'EmailDoesNotContain', 'EmailStartsWith', 'EmailDoesNotStartWith', 'EmailEndsWith', 'EmailBV', 'EmailNBV',

  'PhoneNumber', 'PhoneNumberDoesNotMatch', 'PhoneNumberInlist', 'PhoneNumberContains', 'PhoneNumberStartsWith', 'PhoneNumberEndsWith', 'PhoneNumberBV', 'PhoneNumberNBV',

  'DoNotContact',
  // 'AlumniPrivacy', //AAG-1407 Paul confirmed that users’ privacy settings should not be exposed in reports. 

  // 'PaymentStatus', 'PaymentStatusDoesNotMatch', 'PaymentStatusInlist', 'PaymentStatusStartsWith', 'PaymentStatusEndsWith', 'PaymentStatusContains', 'PaymentStatusBV', 'PaymentStatusNBV',
  // 'RushShipping', //modified AAG-1407 - Based on AAG-1338, referring to the earlier comments from Paul and Raj, the source data is not provided or tracked by Orbital, so these fields cannot capture or return data
// To prevent user confusion and avoid presenting non-functional options in the UI,

  // 'CommunityOrganizationType',
  // 'CommunityOrganizationCategoryCode',

  'CommunityOrganizationTypeName', 'CommunityOrganizationTypeNameDoesNotMatch', 'CommunityOrganizationTypeNameContains', 'CommunityOrganizationTypeNameDoesNotContain', 'CommunityOrganizationTypeNameStartsWith', 'CommunityOrganizationTypeNameDoesNotStartWith', 'CommunityOrganizationTypeNameInlist', 'CommunityOrganizationTypeNameEndsWith', 'CommunityOrganizationTypeNameBV', 'CommunityOrganizationTypeNameNBV', 'CommunityOrgType',

  'CommunityOrganizationCategoryCode', //AAG-1264 set to hidden for now
  // 'CommunityOrganizationCategoryCodeDoesNotMatch',
  // 'CommunityOrganizationCategoryCodeContains',
  // 'CommunityOrganizationCategoryCodeDoesNotContain',
  // 'CommunityOrganizationCategoryCodeStartsWith',
  // 'CommunityOrganizationCategoryCodeDoesNotStartWith',
  'CommunityOrganizationCategoryName',
  'CommunityOrganizationCategoryNameDoesNotMatch',
  'CommunityOrganizationCategoryNameContains',
  'CommunityOrganizationCategoryNameDoesNotContain',
  'CommunityOrganizationCategoryNameStartsWith',
  'CommunityOrganizationCategoryNameDoesNotStartWith',
  'CommunityOrganizationCategoryNameInlist',
  'CommunityOrganizationCategoryNameEndsWith',
  'CommunityOrganizationCategoryNameBV',
  'CommunityOrganizationCategoryNameNBV',
  'Is_Distinguished_Eagle_Scout_Award',
  'Is_Venturing_Summit_Award',
  'Is_Silver_Antelope',
  'Is_Silver_Buffalo',
  'Is_National_Alumnus_of_the_Year_Award',
  'Is_Regional_Alumnus_of_the_Year_Award',
  'Is_NESA_Outstandng_Eagle_Scout_NOESA',
  'Is_Council_Alumnus_of_the_Year_Award',
  'Is_Alumni_Award',
  'Is_Silver_Award',
  'Is_Quartermaster'
]
  .map(f => f.toLowerCase());

const additionalBooleanFilters = ['DoNotContact',
  // 'AlumniPrivacy', //AAG-1407 Paul confirmed that users’ privacy settings should not be exposed in reports. 
  // 'RushShipping',
].map(f => f.toLowerCase());;

export const BooleanFilters = filters.map(filter => {
   if (filter.includes('is_') || additionalBooleanFilters.includes(filter)) return filter;
})

export const REMOVED_SEARCHFILTERS = [// Paul confirmed in the email titled "Updated list" to remove the following filters on 04/16/2026
    // 'business_addressline1',  'positionname', 'positionstartdate', 'business_addressline3',
    'facebookname',
    'business_addressline2', 'twittername', 'linkedinname',
    // 'positionenddate', 'instagramname', 'positioncreationdate',
    
    //  'business_zip4', 'certificatename',
    'ship_to_name', 
    'programid',
    // 'business_city', 
    // 'business_state',
    'ship_to_addressline1', 'ship_to_addressline2',
    'Alpha Phi Omega', 'ship_to_addressline3',
    'shipping_addressline1', 'American Wood Badge Alumni', 'ship_to_zip5',
    'shipping_addressline2', 'Charles L Sommers Alumni Association', 'ship_to_zip4',
    'shipping_addressline3', 'National Eagle Scout Association', 'ship_to_city',
    'National Organization of Sea Scouts', 'ship_to_state',
    'Philmont Staff Association', 'ship_to_country',
    'SBR Staff Association Sea Base Alumni & Friends', 
    'Venturing Alumni', 
    // 'email',
    'fkcamplookupid', 
    // 'eaglescoutcountry', 
    // 'boardofreviewdt',
    //  'eaglescoutunittype',
    // 'eaglescoutunitnumber',
    // 'eaglescoutunitcity',
    // 'eaglescoutunitstate',
    // 'eaglecouncilnameandnumber',
    
    // 'currentcoucilnameandnumber',
     'facebookname',
    'national_alumnus_of_the_month', 'twittername',
    'linkedinname',
    'council_alumnus_of_the_year', 
    'instagramname', 'ship_to_name',
     'National Organization of Sea Scouts Philmont Staff Association SBR Staff Association Sea Base Alumni & Friends Venturing Alumni', 'distinguished_eagle_scout', 

    // 'venturing_summit_award', //Requested in Mike Boggs' spreadseet "SPARK Fields MB 051326" -- AAG-1357 
    // 'National_Alumnus_of_the_Year_Award',
    // 'silver_antelope', 
    // 'silver_award',
    // 'silver_buffalo', 
    // 'Distinguished_Eagle_Scout_Award',
    //  'Regional_Alumnus_of_the_Year_Award', 'NESA_Outstandng_Eagle_Scout_NOESA', 'Council_Alumnus_of_the_Year_Award', 
    
    // 'CurrentCouncilNameAndNumber',
    
    
    // 'quartermaster', 'Alumni_Award', 'AlumniPrivacy', 'business_country', 'business_zip5', 'NESA_City', 'NESA_Country', 'NESA_State', 'NESA_Zip4', 'NESA_Zip5', 'OwnerCouncilNameAndNumber', 'shipping_zip5', 'shipping_zip4', 'shipping_city', 'shipping_country', //According to Mike Boggs' spreadsheet "SPARK Fields - filters for searching MB 120225," the following filters should be displayed in the filter.
];


export const nationalAwards = [ //We received the following awards from Igor. He said he got it from Mike Creagh.
  "Whitney M. Young, Jr. Award",
  "George Meany Award",
  "District Award of Merit",
  "Silver Beaver",
  "Silver Antelope",
  "Silver Buffalo",
  "Silver World",
  "Silver Award",
  "Bronze Wolf (World Scouting)",
  "Distinguished Eagle Scout Award",
  "Hornaday Gold Medal",
  "N. E. S. A. Scoutmaster Award",
  "National President's Scoutmaster Aw",
  "William H. Spurgeon Award",
  "Venturing Ldrship Awd. (Cncl. Adult",
  "Venturing Ldrship Awd. (Reg. Adult)", //---
  "Venturing Ldrship Awd. (Natl. Adult",
  "Venturing Summit Award",
  "William T. Hornaday Gold Badge",
  "Em. Preparedness BSA - Adult",
  "SCUBA BSA (Adult)",
  "Leave No Trace (Adult-BS/Vent.)",
  "Leave No Trace (Adult-Cub Scout)",
  "Kayaking BSA (Adult)",
  "William D. Boyce Organizer Award",
  "Veteran Award - 5 Years",
  "Veteran Award - 10 Years",
  "Veteran Award - 15 Years",
  "Veteran Award - 20 Years",
  "Veteran Award - 25 Years",
  "Veteran Award - 30 Years",
  "Veteran Award - 35 Years",
  "Veteran Award - 40 Years",
  "Veteran Award - 45 Years",
  "Veteran Award - 50 Years",
  "Veteran Award - 55 Years",
  "Veteran Award - 60 Years",
  "Veteran Award - 65 Years",
  "Veteran Award - 70 Years",
  "Veteran Award - 75 Years",
  "Veteran Award - 80 Years",
  "Veteran Award - 85 Years",
  "Veteran Award - 90 Years",
  "Veteran Award - 95 Years",
  "Veteran Award - 100 Years",
  "International Scouter's Award",
  "Scouting...Vale La Pena Service Awd",
  "Asian American Award",
  "Venturing Ldrship Awd. (Area Adult)",
  "BSA Physical Fitness Award (Adult)",
  "Marvin M. Lewis Award (Elks)",
  "VFW Scouter's Achievement Award",
  "American Legion Scouting Square Kno",
  "DoD-USM Outstanding Volunteer Svc.",
  "Herbert G. Horton APO Youth Svc Awd",
  "Cliff Dochterman Award (Rotary)",
  "Ruritan Scout Ldr Community Svc Awd",
  "Raymond A Finley, Jr. Sea Scout Svc",
  "Daniel Carter Beard Masonic Scouter",
  "Special Needs Scouting Service Awd",
  "Unit Leader Award of Merit - CM",
  "Unit Leader Award of Merit - SM",
  "Unit Leader Award of Merit - VC",
  "Unit Leader Award of Merit - NL",
  "Philmont Master's Track Award",
  "Alumni Award",
  "James E. West Fellowship Award",
  "NESA Outstandng Eagle Scout (NOESA)",
  "Commissioner Awd Excellence Unit Sv",
  "Outdoor Ethics Awareness Award-ADLT",
  "Outdoor Ethics Action Award - CS-AD",
  "Outdoor Ethics Action Award - BS-AD",
  "Outdoor Ethics Action Award - VS-AD",
  "Outdoor Ethics Action Award-VEN-AD",
  "(Adult) Stand Up Paddleboarding BSA",
  "Coun Sea Scout Leadership (Adult)",
  "Area Sea Scout Leadership (Adult)",
  "Torch of Gold Award",
  "Alpha Phi Alpha Good Turn Service",
  "Reg Sea Scout Leadership (Adult)",
  "Natl Sea Scout Leadership (Adult)",
  "National Alumnus of the Month",
  "Council Alumnus of the Year Award",
  "Regional Alumnus of the Year Award",
  "National Alumnus of the Year Award",
  "International Spirit Award (Adult)",
  "NESA Legacy Society Award (Adult)",
  "American Wood Badge 70th Annv Award",
  "Fretwell Outstanding Educator Award",
  "BSA Distinguished Conservationist",
  "Loc. Council Cert. of Merit (Adult)",
  "Natl Council Cert. of Merit (Adult)",
  "Medal of Merit (Adult)",
  "Heroism Award (Adult)",
  "Honor Medal (Adult)",
  "Honor Medal With Crossed Palms (Adu",
  "WOODBADGE COURSE",
  "WOODBADGE COMPLETE",
  "WOODBADGE STAFF",
  "WB COURSE DIRECTOR",
  "RELIGIOUS AWARD",
  "Founder's Bar (Adult)",
  "Second Century Society"
];

export default { Admin, AlumniSpecialist, REMOVED_SEARCHFILTERS, nationalAwards, OPERATOR_MAP, filters }




// WEBPACK FOOTER //
// ./src/auth.js